/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class CheckWhetherUserCanCreateMeetingsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation canCreateMeetings
   */
  static readonly CanCreateMeetingsPath = '/meetings/can/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canCreateMeetings()` instead.
   *
   * This method doesn't expect any request body.
   */
  canCreateMeetings$Response(params?: {
  }): Observable<StrictHttpResponse<{
'value'?: boolean;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CheckWhetherUserCanCreateMeetingsService.CanCreateMeetingsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'value'?: boolean;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canCreateMeetings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canCreateMeetings(params?: {
  }): Observable<{
'value'?: boolean;
}> {

    return this.canCreateMeetings$Response(params).pipe(
      map((r: StrictHttpResponse<{
'value'?: boolean;
}>) => r.body as {
'value'?: boolean;
})
    );
  }

}
